<template>
    <div class="share-watchlist-modal-tabs">
        <span
            v-on:click="changeTab(1)"
            class="share-watchlist-modal-tabs__top-tabs-button"
            :class="{ active: shareWatchListActiveTab === 1 }"
        >
            <span v-html="$t('WatchListModal.share_watchlist_tabs_not_shared')"></span>
            {{ getSumOfNotSharedSubordinates }}
        </span>
        <span
            class="share-watchlist-modal-tabs__top-tabs-button"
            v-on:click="changeTab(2)"
            :class="{ active: shareWatchListActiveTab === 2 }"
        >
            <span v-html="$t('WatchListModal.share_watchlist_tabs_shared')"></span>
            {{ getSumOfSharedSubordinates }}
        </span>
        <span v-if="isDesktopView" class="share-watchlist-modal-tabs__border-fill"></span>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        name: 'ShareWatchListTabs',
        props: {
            subordinates: Array,
            members: Array
        },
        computed: {
            ...mapGetters({
                shareWatchListActiveTab: 'Watchlists/getShareWatchListTab'
            }),
            getSumOfSharedSubordinates () {
                if (!this.members) {
                    return '(0)'
                }
                return '(' + this.members.length + ')'
            },
            getSumOfNotSharedSubordinates () {
                if (!this.subordinates) {
                    return '(0)'
                }
                return '(' + this.subordinates.length + ')'
            }
        },
        methods: {
            changeTab (tab) {
                this.$store.dispatch('Watchlists/shareWatchListChangeTab', tab)
            }
        }
    }
</script>

<style lang="scss" scoped>
    .share-watchlist-modal-tabs {
        justify-content: flex-end;
        display: flex;
        width: 100%;

        [class*="mobile"] & {
            margin: 10px 0 0 0;
        }

        &__top-tabs-button {
            font-family: Nunito-Bold;
            justify-content: center;
            width: 100%;
            font-size: 1.4rem;
            align-items: center;
            display: flex;
            cursor: pointer;
            border-bottom: 2px solid $black;

            &.active {
                color: $orange;
                border-bottom: 2px solid $orange;
            }
        }
        &__search-input {
            border-bottom: 2px solid $black;
        }
        &__border-fill {
            border-bottom: 2px solid $black;
            width: 100%;
        }
    }
</style>
